// extracted by mini-css-extract-plugin
export default {"container":"successModal_container__iKP14","title":"successModal_title__o+JhR","closeButton":"successModal_closeButton__A6jKo","header":"successModal_header__Glzwn"};